// F4 Report 15: Site Masking Pending
import React, { useEffect, useState } from "react";
import { fetchReportSiteMaskingPending } from "../../api/service";
import ReportShell, { display, downloadReportCsv } from "./ReportShell";

const SiteMaskingPendingReport = () => {
  const [rows, setRows] = useState([]);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let alive = true;
    fetchReportSiteMaskingPending()
      .then((res) => { if (!alive) return; setRows(res?.rows || []); setCount(res?.count || 0); })
      .catch((e) => alive && setError(e?.message || "Failed to load"))
      .finally(() => alive && setLoading(false));
    return () => { alive = false; };
  }, []);

  return (
    <ReportShell
      title="15. Site Masking Pending"
      count={count}
      loading={loading}
      error={error}
      onExport={() => downloadReportCsv("site_masking_pending")}
    >
      <div className="table-responsive">
        <table className="table table-bordered table-hover align-middle">
          <thead className="table-light">
            <tr>
              <th className="text-center">Project</th>
              <th className="text-center">Civil Engineer</th>
              <th className="text-center">Ageing (days)</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr><td colSpan={3} className="text-center text-muted py-4">Nothing to report.</td></tr>
            ) : rows.map((r) => (
              <tr key={r.project_id}>
                <td className="text-center">{r.project_label}</td>
                <td className="text-center">{display(r.civil_members)}</td>
                <td className="text-center">{display(r.ageing_days)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </ReportShell>
  );
};

export default SiteMaskingPendingReport;
